import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en.json";
import translationFI from "./fi.json";
import translationET from "./et.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    fi: { translation: translationFI },
    et: { translation: translationET },
  },
  lng: localStorage.getItem("i18nextLng") || "et",
  fallbackLng: "et",
  interpolation: { escapeValue: false },
});
// console.log(i18n, "i18n")

export default i18n;
